// extracted by mini-css-extract-plugin
module.exports = {"notesWrapper":"styles-module__notesWrapper___tovng","noteTimestamp":"styles-module__noteTimestamp___2aP-y"};